import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { HvlAbstractLazyList } from '@hvlng/framework-core/form';
import { Subscription } from 'rxjs';
import { UiTranslateLoaderService } from 'ui-shared';
import { PerOrganizationGeneralInfoModel } from '../model/per-organization-general-info-model';
import { StaffFullnessStatusEnum } from '../staff-fullness-enum';
import {
    LookupModel,
    ProvinceQueryModel,
    ProvinceService,
    SubprovinceQueryModel,
    SubprovinceService,
} from 'infrastructure-shared';
import { OrganizationDefinitionQueryModel } from '../model/organization-definition-query-model';
import { PersonnelSharedService } from '../../../../service/personnel-shared-service';

@Component({
    selector: 'organization-selection-search-form',
    templateUrl: './organization-selection-search-form.component.html',
})
export class OrganizationSelectionSearchFormComponent
    extends HvlAbstractLazyList<PerOrganizationGeneralInfoModel>
    implements OnInit {
    staffFullnessStatusEnumList = [];
    list;
    @Input() pageCode: string;
    @Input() form: UntypedFormGroup;
    @Output() valueEvent = new EventEmitter<any>();
    @Input() isClear: boolean;
    @Output() onBack = new EventEmitter();
    private subscription: Subscription;
    selectedModel;
    @Output() onSearchEvent = new EventEmitter();
    @Input() showStaffFullnessStatus;
    provinceList: Array<LookupModel>;
    subProvinceList: Array<LookupModel>;
    constructor(private service: PersonnelSharedService, private provinceService: ProvinceService,
                private subProvinceService: SubprovinceService, protected translateService: UiTranslateLoaderService) {
        super();
    }

    ngOnInit(): void {
        this.staffFullnessStatusEnumList = [];
        Object.keys(StaffFullnessStatusEnum).map((item) => {
            let tLabel = this.translateService.instant('orgPicker.staffFullnessStatusEnum.' + item);
            this.staffFullnessStatusEnumList.push({ label: tLabel, value: StaffFullnessStatusEnum[item] });
        });
        this.form.get('staffFullnessStatus').setValue('0');

        let qm = new ProvinceQueryModel();
        this.provinceService.lookupQuery(qm).subscribe((res) => {
            this.provinceList = res;
        });
    }

    onSearch(event: any) {
        let queryModel = new OrganizationDefinitionQueryModel();
        queryModel.pageable = { sort: {}, pageNumber: 0, pageSize: 100 };
        queryModel.perObjectDefinitionText = event.query;

        this.subscription = this.service.queryOrganizationPage(queryModel).subscribe((res) => (this.list = res.data));
    }

    onSelect(event: any) {
        this.selectedModel = event;
        this.form.get('perObjectDefinitionPId').setValue(this.selectedModel.perObjectDefinitionId);
        this.valueEvent.emit(this.selectedModel);
    }

    onClear() {
        this.selectedModel = null;
        this.form.get('perObjectDefinitionPId').setValue(null);
        this.valueEvent.emit(null);
    }

    ngOnDestroy(): void {
        if (this.subscription) this.subscription.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.isClear?.currentValue) {
            this.onClear();
            this.onBack.emit();
        }
    }

    onKeyDownEvent() {
        this.onSearchEvent.emit();
    }

    fetchSubProvinceList() {
        let qm = new SubprovinceQueryModel();
        qm.provinceId = this.form.getVal('provinceId');
        this.subProvinceService.lookupQuery(qm).subscribe((res) => {
            this.subProvinceList = res;
        });
    }

}
